import { Icon } from '@adobe/react-spectrum';

const RightArrowIcon = props => {
  return (
    <Icon {...props}>
      <svg
        class="spectrum-UIIcon-ChevronRightLarge"
        focusable="false"
        aria-hidden="true"
        role="img"
      >
        <path d="M11.5 8a1.241 1.241 0 0 0-.386-.897L4.128.36a1.248 1.248 0 1 0-1.733 1.797L8.45 8l-6.058 5.84a1.248 1.248 0 1 0 1.733 1.797L11.117 8.9A1.245 1.245 0 0 0 11.5 8z"></path>
      </svg>
    </Icon>
  );
};

export default RightArrowIcon;
